export default {
  languageID: 'TR',
  uuidnavimessage: Math.random()
}
